"use strict";

require("core-js/modules/es6.regexp.split");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  return String(value).split(',');
};